// src/lib/headsUpLinks.js — the links a heads-up may show: only to the
// person's own Google Calendar event or Gmail message, over https. Anything
// else is dropped, never rendered (Janet's chat never turns text into links).

const ALLOWED = [
  { host: 'calendar.google.com' },
  { host: 'www.google.com', path: /^\/calendar\// },
  { host: 'mail.google.com' },
]

export function safeHeadsUpLinks(links) {
  const out = []
  for (const l of Array.isArray(links) ? links : []) {
    let u
    try { u = new URL(String(l?.url || '')) } catch { continue }
    if (u.protocol !== 'https:') continue
    if (!ALLOWED.some(a => a.host === u.hostname && (!a.path || a.path.test(u.pathname)))) continue
    const label = String(l?.label || '').replace(/\s+/g, ' ').trim().slice(0, 80) || 'Open'
    out.push({ label, url: u.toString() })
  }
  return out.slice(0, 8)
}
